<template>
  <div>
    <div>
      <draggable
        class="guestbook-boxes"
        v-model="computedBoxesData"
        handle=".dragBoxIcon"
        @start="drag = true"
        @end="drag = false"
        @sort="onSort(boxesData)"
      >
        <div
          class="sortable-handle guestbook-boxes__box-container"
          :class="{
            'disable-transform': activeModal,
            'box-type__voucher': box.type === 'voucher',
            'box-type__standard': box.type === 'standard',
            'box-type__info': box.type === 'info',
            'box-type__form': box.type === 'form',
            'box-type__key': box.type === 'key',
          }"
          v-for="(box, index) in computedBoxesData"
          :key="index"
        >
          <StandardBox
            v-if="box.type === 'standard'"
            :box="box"
            :index="index"
            :activeFABIndex="activeFABIndex"
            :boxes="boxes"
            :customFonts="customFonts"
            :languageTypesIndex="languageTypesIndex"
            :pagesOverview="pagesOverview"
            @toggleModal="activeModal = $event"
            @passActiveIndex="activeFABIndex = $event"
          />
          <InformationBox
            v-if="box.type === 'info'"
            :box="box"
            :index="index"
            :activeFABIndex="activeFABIndex"
            :boxes="boxes"
            :customFonts="customFonts"
            :languageTypesIndex="languageTypesIndex"
            @toggleModal="activeModal = $event"
            @passActiveIndex="activeFABIndex = $event"
          />
          <VoucherBox
            v-if="box.type === 'voucher'"
            :box="box"
            :index="index"
            :activeFABIndex="activeFABIndex"
            :boxes="boxes"
            :customFonts="customFonts"
            :languageTypesIndex="languageTypesIndex"
            @toggleModal="activeModal = $event"
            @passActiveIndex="activeFABIndex = $event"
          />
          <FormBox
            v-if="box.type === 'form'"
            :initialEditModal="addFormModal"
            :box="box"
            :index="index"
            :activeFABIndex="activeFABIndex"
            :boxes="boxes"
            :customFonts="customFonts"
            :languageTypesIndex="languageTypesIndex"
            @formModalEditable="addFormModal = false"
            @toggleModal="activeModal = $event"
            @passActiveIndex="activeFABIndex = $event"
          />
          <KeyBox
            v-if="box.type === 'key'"
            :box="box"
            :index="index"
            :activeFABIndex="activeFABIndex"
            :boxes="boxes"
            :customFonts="customFonts"
            :languageTypesIndex="languageTypesIndex"
            :pagesOverview="pagesOverview"
            @toggleModal="activeModal = $event"
            @passActiveIndex="activeFABIndex = $event"
          />
        </div>
        <!-- The begining of add-box button -->
        <div
          v-on:click="showChooseBoxModal = true"
          class="add-box"
          :style="{
            color: changePreviewColorText,
            'border-color': changePreviewColorText,
          }"
        >
          <v-icon name="plus" scale="3.4"></v-icon>
        </div>
        <!-- End of add-box button  -->
      </draggable>
    </div>
    <transition name="fadeInModal">
      <!--<choose-box-modal
      @information="addNewBox(newInformationObj)"
      @box="addNewBox(newBoxObj)"
      @voucher="addNewBox(newVoucherObj)"
      @form="addNewBox(newFormObj)"
      @close="closeChooseBox"
      v-if='showChooseBoxModal'>
      <p slot = 'text'>What would you like to create?</p>
    </choose-box-modal> -->
      <ChooseBoxModal
        @information="() => addNewBox(newInformationObj)"
        @box="addNewBox(newBoxObj)"
        @voucher="addNewBox(newVoucherObj)"
        @form="addNewBox(newFormObj)"
        @key="addNewBox(newKeyObj)"
        @close="closeChooseBox"
        v-if="showChooseBoxModal"
      >
      </ChooseBoxModal>
    </transition>
  </div>
</template>

<script>
import StandardBox from "../BoxesComponents/StandardBox/StandardBox";
import InformationBox from "../BoxesComponents/InformationBox/InformationBox";
import VoucherBox from "../BoxesComponents/VoucherBox/VoucherBox";
import FormBox from "../BoxesComponents/FormBox/FormBox";
import KeyBox from "../BoxesComponents/KeyBox/KeyBox";

import ChooseBoxModal from "@/components/EditGuestbookPage/ChooseBoxModal.vue";
import returnUTCTimeMixin from "@/mixins/returnUTCTimeMixin";
import generateUuidMixin from "@/mixins/generateUuidMixin";
import draggable from "vuedraggable";
import { db, firestore } from "@/firebase";
import bus from "@/bus.js";

export default {
  components: {
    StandardBox,
    InformationBox,
    VoucherBox,
    FormBox,
    KeyBox,
    draggable,
    ChooseBoxModal,
  },
  mixins: [returnUTCTimeMixin, generateUuidMixin],
  props: {
    boxes: Array,
    pagesOverview: Object,
    forms: Array,
    customFonts: Object,
    languageTypesIndex: Number,
  },
  data() {
    return {
      activeFABIndex: null,
      activeModal: false,
      addFormModal: false,
      showChooseBoxModal: false,
      boxesData: {},
      newBoxObj: {
        type: "standard",
        visibility: {
          precheckin: true,
          checkin: true,
          anonymous: true,
        },
        boxColor: "#98DCF1",
        boxText: "#FFFFFF",
        btncolor: "#FFFFFF",
        btntext: "#98DCF1",
        buttonTitles: ["Btn text", "Btn sec text"],
        httpLinks: [
          "None"
        ],
        icon: "hotel",
        iconColor: "#FFFFFF",
        iconImage: "none",
        backgroundImage: "none",
        page: "None",
        pageName: "None",
        showButton: false,
        showIcon: true,
        showIconImage: false,
        showBgImage: false,
        texts: [
          "Some text here",
          "Some text here"
        ],
        textsTwo: [
          "Some other text",
          "Some other text"
        ],
        titles: [
          "YOUR TITLE",
          "YOUR TITLE"
        ]
      },
      newInformationObj: {
        type: "info",
        visibility: {
          precheckin: true,
          checkin: true,
          anonymous: true,
        },
        boxColor: "#FFFFFF",
        boxText: "#000000",
        checkins: ["[Insert time]", "[Insert time]"],
        checkouts: ["[Insert time]", "[Insert time]"],
        checkinTexts: ["Checkin", "Checkin"],
        checkoutTexts: ["Checkout", "Checkout"],
        headline: "HOTEL INFORMATION",
        roomAbilities: [
          {
            allowed: 0,
            allowedHeaderContent: true,
            iconName: 0,
            title: "Free WiFi",
            titles: {0: "Free WiFi"}
          },
          {
            allowed: 0,
            iconName: 0,
            allowedHeaderContent: true,
            title: "Parking",
            titles: {0: "Parking"}
          },
          {
            allowed: 0,
            iconName: 0,
            allowedHeaderContent: true,
            title: "Fitness: Free Access",
            titles: {0: "Fitness: Free Access"}
          },
        ],
      },
      newVoucherObj: {
        type: "voucher",
        visibility: {
          precheckin: true,
          checkin: true,
          anonymous: true,
        },
        id: "generatedByGenerateUniqueIdForVoucher method",
        title: "One free drink",
        titleSec: "",
        text: "Voucher for the bar on the ground floor of the hotel",
        textSec: "",
        iconImage:
          "https://images.unsplash.com/photo-1552841872-a0841f72a4ee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=362&q=80",
        redeem: [""],
        boxText: "#000000",
        boxColor: "#FFFFFF",
        btnTextColor: "#FFFFFF",
        btnColor: "#98DCF1",
        showButton: true,
        button: "REDEEM",
        buttonSec: "",
        buttonConfirm: "FOR STAFF - CONFIRM?",
        buttonConfirmSec: "",
        counter: 0,
        createdAt: this.returnUTCTime(),
        active: true,
      },
      newFormObj: {
        type: "form",
        buttonText: "SEE OUR SELECTION",
        buttonTextSec: "SEE OUR SELECTION",
        backgroundImage:
          "https://images.unsplash.com/photo-1552841872-a0841f72a4ee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=362&q=80",
        visibility: {
          precheckin: false,
          checkin: false,
          anonymous: false,
        },
        currency: this.$currency ? this.$currency : "kr.",
        id: "notgeneratedyet",
        email: this.$formEmail,
        title: "",
        titleSec: "",
        subtitle: "",
        subtitleSec: "",
        customNoteHeader: "",
        customNoteHeaderSec: "",
        customNoteDescription: "",
        customNoteDescriptionSec: "",
        formColor: "#8EB9C8",
        textColor: "#FFFFFF",
        categories: [
          {
            items: [
              {
                title: "Your sample item!",
                titleSec: "Your sample second lang item!",
                descriptions: [
                  "",
                  ""
                ],
                price: 100,
                amount: 0,
              },
            ],
            title: "",
            titleSec: "",
          },
        ],
        inputs: [
          {
            type: "EMAIL",
            isRequired: true,
            labels: [
              "", 
              ""
            ]
          }
        ],
        isCustomInputsEnabled: false,
        isCustomNoteEnabled: false,
        serviceCharge: 0,
      },
      newKeyObj: {
        type: "key",
        visibility: {
          precheckin: true,
          checkin: true,
          anonymous: true,
        },
        boxColor: "#FFFFFF",
        boxTextColor: "#AAAAAA",
        graphicColor: "#8FB9C7",
        buttonColor: "#FFFFFF",
        buttonTextColor: "#8FB9C7",
        buttonTexts: ["GET YOUR DIGITAL KEY", "2GET YOUR DIGITAL KEY"],
        boxTexts: [
          "We use digital keys! Get yours for your room",
          "2We use digital keys! Get yours for your room",
        ],
        linkAndroid:
          "https://play.google.com/store/apps/details?id=com.assaabloy.hospitality.mobileaccess.hospitalitymobileaccess&hl",
        linkiOS:
          "https://apps.apple.com/dk/app/hospitality-mobile-access/id1017290566?l",
      },
      guestbookBodyColor: null
    };
  },
  created() {
    db.ref(`/hotels/${this.$customerId}/${this.$hotelId}/nav/guestbookBodyColor`)
      .on('value', snapshot => {
        this.guestbookBodyColor = snapshot.val()
      })
  },
  computed: {
    computedBoxesData: {
      get: function () {
        return this.boxes;
      },
      set: function (newData) {
        this.boxesData = newData;
      },
    },
    changePreviewColorText() {
      //Gets chosen background color
      let hex = this.guestbookBodyColor;
      let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

      let hRed = hexToR(hex);
      let hGreen = hexToG(hex);
      let hBlue = hexToB(hex);

      function hexToR(h) {
        return parseInt(cutHex(h).substring(0, 2), 16);
      }
      function hexToG(h) {
        return parseInt(cutHex(h).substring(2, 4), 16);
      }
      function hexToB(h) {
        return parseInt(cutHex(h).substring(4, 6), 16);
      }
      function cutHex(h) {
        return String(h).charAt(0) == "#"
          ? String(h).substring(1, 7)
          : String(h);
      }
      let cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
      if (cBrightness > threshold) {
        return "#000000";
      } else {
        return "#FFFFFF";
      }
    },
  },
  methods: {
    generateUniqueIdForVoucher() {
      this.newVoucherObj.id = this.generateUUID();
    },
    onSort: function (updatedData) {
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/`).set(updatedData);
    },
    closeChooseBox() {
      bus.$emit("bodyOverflow", false);
      this.showChooseBoxModal = false;
    },
    addNewBox(boxObj) {
      switch (boxObj.type) {
        case "standard":
          this.addToDatatabase(boxObj);
          break;
        case "info":
          this.addToDatatabase(boxObj);
          break;
        case "voucher":
          this.generateUniqueIdForVoucher();
          this.addToFirestore(boxObj);
          this.addToDatatabase(boxObj);
          break;
        case "form":
          bus.$emit("bodyOverflow", true);
          this.addFormModal = true;
          this.addToDatatabase(boxObj);
          break;
        case "key":
          this.addToDatatabase(boxObj);
          break;
      }
    },
    async addToDatatabase(boxObj) {
      var newObjToFirebase = this.computedBoxesData;
      newObjToFirebase.push(boxObj);
      await db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/`).set(newObjToFirebase);
      this.showChooseBoxModal = false;
    },
    addToFirestore(boxObj) {
      return firestore
        .doc(`VoucherStatistics/${this.$hotelId}/Vouchers/${boxObj.id}`)
        .set({
          Name: boxObj.title,
          TotalRedeems: boxObj.counter,
          CreatedAt: boxObj.createdAt,
          Active: boxObj.active,
        });
    },
  },
};
</script>

<style scoped>
.sortable-handle {
  position: relative;
  float: left;
}

.disable-transform {
  transform: unset !important;
}

* {
  box-sizing: border-box;
}

.add-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: rgba(0, 0, 0, 0.2);
  border: 4px dashed rgba(0, 0, 0, 0.2);
  cursor: pointer;
  float: left;
  border-radius: 8px;
}

.guestbook-boxes {
  display: grid;
  width: 100%;
  max-width: 460px;
  padding: 20px;
  margin: 0 auto;

  /* Overall grid control */
  grid-template-columns: 100%;
  grid-auto-rows: 120px;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}

.guestbook-boxes__box-container {
  max-width: 420px;
}

.box-type__standard,
.box-type__voucher,
.box-type__form,
.add-box {
  grid-row: span 2;
}

.box-type__info {
  grid-row: span 4;
  grid-row-start: auto;
}

.box-type__key {
  grid-row: span 1;
}

.guestbook-boxes__box-container__standard,
.guestbook-boxes__box-container__info,
.guestbook-boxes__box-container__voucher,
.guestbook-boxes__box-container__form {
  height: 100%;
}

@media screen and (min-width: 700px) {
  .guestbook-boxes {
    width: 700px;
    max-width: none;

    /* When tablet size-ish, create 2 columns of 320px */
    grid-template-columns: 320px 320px;
  }
}

@media screen and (min-width: 1040px) {
  .guestbook-boxes {
    width: 1040px;

    /* When laptop size-ish, create 3 columns of 320px */
    grid-template-columns: 320px 320px 320px;
    grid-auto-rows: 240px;
  }

  .box-type__key,
  .box-type__standard,
  .box-type__voucher,
  .box-type__form,
  .add-box {
    grid-row: span 1;
    grid-row-start: auto;
  }

  .box-type__info {
    grid-row: span 2;
    grid-row-start: auto;
  }
}
</style>
